// Error request bisa tanpa response: jaringan putus, dibatalin router, atau bug kode. Murni, nol import.

const statusOf = (e) => e?.response?.data?.status;

// Sama dengan axios.isCancel di axios 0.19.
export function isCancelled(e) {
  return Boolean(e && e.__CANCEL__);
}

export function isAuthError(e) {
  return statusOf(e)?.message === 'Authentication Error';
}

export function requestErrorMessage(e, fallback = 'Network error') {
  const message = statusOf(e)?.message;
  return typeof message === 'string' && message ? message : fallback;
}
